import { createBrowserRouter, Outlet } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { Header } from './components';
import ProtectedRoute from './components/ProtectedRoute';

// Lazy loaded pages
const LandingPage = lazy(() => import('./pages/Landing'));
const CatalogPage = lazy(() => import('./pages/Catalog'));
const SetDetailPage = lazy(() => import('./pages/SetDetail'));
const DashboardPage = lazy(() => import('./pages/Dashboard'));
const LoginPage = lazy(() => import('./pages/Login'));
const CartPage = lazy(() => import('./pages/Cart'));
const CheckoutPage = lazy(() => import('./pages/Checkout'));
const SubscriptionPage = lazy(() => import('./pages/Subscription'));
const RentalHistoryPage = lazy(() => import('./pages/RentalHistory'));
const WaitlistPage = lazy(() => import('./pages/Waitlist'));
const ReturnPage = lazy(() => import('./pages/Return'));
const PreferencesPage = lazy(() => import('./pages/Preferences'));
const PauseSubscriptionPage = lazy(() => import('./pages/PauseSubscription'));
const NotFoundPage = lazy(() => import('./pages/NotFound'));

// Loading fallback component - exported for use in router config
export function PageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-brick-500 border-t-transparent" />
    </div>
  );
}

// Root layout component - exported for use in router config
export function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'catalog',
        element: <CatalogPage />,
      },
      {
        path: 'set/:setId',
        element: <SetDetailPage />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      // Protected routes - require authentication
      {
        path: 'cart',
        element: (
          <ProtectedRoute>
            <CartPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'checkout',
        element: (
          <ProtectedRoute>
            <CheckoutPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'subscription',
        element: <SubscriptionPage />,
      },
      {
        path: 'history',
        element: (
          <ProtectedRoute>
            <RentalHistoryPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'waitlist',
        element: (
          <ProtectedRoute>
            <WaitlistPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'return/:setId',
        element: (
          <ProtectedRoute>
            <ReturnPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'preferences',
        element: (
          <ProtectedRoute>
            <PreferencesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'pause-subscription',
        element: (
          <ProtectedRoute>
            <PauseSubscriptionPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
